import React from 'react';
import { useHistory } from 'react-router-dom';
import { Block, Heading, Icon, Text } from '../../../../../../components';
import { BackButton, ToggleCard } from '../../../../components';
import moneyIcon from '../../../../../../../assets/icons/icon-money.svg';
import lineIcon from '../../../../../../../assets/icons/icon-line.svg';
import alertCircleIcon from '../../../../../../../assets/icons/alert-circle-v2.svg';
import clockIcon from '../../../../../../../assets/icons/icon-clock-black.svg';
import Processing from '@/presentation/components/Processing';
import Spinner from '../../../../../../components/Spinner';
import Step from '../../UpdatePhoto/Register/components/Step';
import routes from '../../../../../../components/Routes/routingMap';
import {
  ContainerProcedure,
  SubContainer
} from '../../../certificates-constancies/type1/info/components';
import { CommonBlock, ContainerCard, RegisterBtn } from './components/styled';
import { ContainerRadio } from '../../../scholarships/bse/components/styles';
import { ProcedureInfoComponent } from '../info/components/ProcedureInfoComponent';
import Modal from '../../../../components/Modal/Modal';
import ConfirmationModal from '../info/components/Modals/ConfirmationModal';
import Select from '../../../../../../reusables/Select';
import { Input } from './components/Input';

const IssuanceUniversityCardRegisterView = (props: any) => {
  const {
    procedure,
    profile,
    isLoading,
    phone,
    direction,
    detail,
    deliveryMode,
    districtId,
    validateField,
    errorPhone,
    registerIssuance,
    resultFormPrint,
    showConfirmationModal,
    handleCloseConfirmationModal,
    setShowConfirmationModal,
    campusList,
    selectCampus,
    campusName,
    handlerSelectCampus
  } = props;

  const history = useHistory();

  return (
    <ContainerProcedure>
      <Block customized alignItems="center" justifyContent="center">
        <Block customized justifyContent="flex-start" margin="0px 0px 16px">
          <BackButton
            onClick={() => {
              /* if (fileExists) setIsQuit(true);
                  else */
              history.push(
                routes.student.procedures.categories.requests
                  .issuancefuniversitycard.procedureinfo
              );
            }}
          />
        </Block>
        {!procedure && <Spinner />}
        <SubContainer>
          {procedure && (
            <Block
              customized
              alignItems="flex-start"
              justifyContent="flex-start"
            >
              <ToggleCard>
                <Text
                  color="#161D1F"
                  fontSize="14px"
                  lineHeight="20px"
                  fontWeight="900"
                >
                  {procedure?.name}
                </Text>
                <Block
                  customized
                  flexDirection="row"
                  alignItems="center"
                  margin="0px 0px 12px 0px"
                >
                  <Icon
                    customized
                    maxWidth="16.9px"
                    height="15px"
                    margin="0px 4.67px 0px 0px"
                  >
                    <img src={moneyIcon} alt="other" />
                  </Icon>
                  <Text
                    color="#161D1F"
                    fontSize="14px"
                    lineHeight="20px"
                    fontWeight="400"
                  >
                    Costo:{' '}
                    <span
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '14px',
                        fontWeight: 900,
                        color: '#161D1F'
                      }}
                    >
                      S/ {procedure?.amount}
                    </span>
                  </Text>
                  <Icon
                    customized
                    maxWidth="1px"
                    height="13px"
                    margin="0px 0px 0px 16px"
                  >
                    <img src={lineIcon} alt="other" />
                  </Icon>
                  <Icon
                    customized
                    maxWidth="13.33px"
                    margin="0px 5.33px 0px 17.33px"
                  >
                    <img src={clockIcon} alt="other" />
                  </Icon>
                  <Text
                    color="var(--text-text02)"
                    fontSize="12px"
                    lineHeight="16px"
                    fontWeight="400"
                  >
                    <span
                      style={{
                        fontFamily: 'Lato',
                        fontSize: '14px',
                        fontWeight: 400
                      }}
                    >
                      {procedure?.duration || ''}
                    </span>
                  </Text>
                </Block>

                <Block customized>
                  <ProcedureInfoComponent
                    deliverySchedule={procedure?.deliverySchedule}
                  />
                </Block>
              </ToggleCard>
              {/* Progreso */}
              <Heading
                text="Progreso"
                level={2}
                color="var(--text-text02)"
                size={18}
                lineHeight={28}
                fontWeight="900"
                className=""
                align="flex-start"
              />

              <CommonBlock>
                <Step
                  name={procedure.steps[0].name}
                  order={procedure.steps[0].order}
                  isCurrent
                >
                  <ContainerCard>
                    <div className="section__container">
                      <div className="section__container--contact">
                        <p className="section__container--paragraph">
                          Contacto
                        </p>
                        <Input
                          value={phone}
                          setValue={validateField}
                          name="phone"
                          placeholder="Ingresa tu número telefónico"
                          showCount
                          maxLength={9}
                          isNumber
                          errorText="Excediste el número de caracteres"
                          error={errorPhone}
                        />
                        <div className="help__contact">
                          <img src={alertCircleIcon} alt="alertCircleIcon" />
                          <p>
                            Necesitamos tu contacto para poder coordinar la
                            entrega de tu documento
                          </p>
                        </div>
                      </div>
                      <div className="section__container--campus">
                        {profile?.campus === 'VIRT' ? (
                          <Select
                            items={campusList}
                            onChange={(v) => handlerSelectCampus(v)}
                            value={selectCampus}
                            placeholder="Selecciona el campus"
                            itemCount={4}
                            itemName={'name'}
                            itemValue={'id'}
                            label={'Campus'}
                          />
                        ) : (
                          <>
                            <p className="section__container--paragraph">
                              Campus de recojo
                            </p>
                            <div
                              style={{ display: 'flex', alignItems: 'center' }}
                            >
                              <ContainerRadio>
                                <div className="circle circle1">
                                  <div
                                    className={'circle circle2'}
                                    style={{
                                      background: 'var(--primary-hover)',
                                      border: 'transparent'
                                    }}
                                  >
                                    <div
                                      className="circle circle3"
                                      style={{ background: 'white' }}
                                    />
                                  </div>
                                </div>
                              </ContainerRadio>
                              <strong>{profile?.campusDesc}</strong>
                            </div>
                          </>
                        )}
                      </div>

                      <RegisterBtn
                        phone={phone.length}
                        direction={direction.length}
                        detail={detail.length}
                        deliveryMode={deliveryMode.length}
                        districtId={districtId}
                        type="button"
                        isProvince={procedure?.isProvince}
                        onClick={() => setShowConfirmationModal(true)}
                        resultFormPrint={resultFormPrint}
                      >
                        <p>Solicitar</p>
                      </RegisterBtn>
                    </div>
                  </ContainerCard>
                </Step>
                <Step
                  name={procedure.steps[1].name}
                  order={procedure.steps[1].order}
                  disabled
                  isCurrent
                />
                <Step
                  name={procedure?.steps[2]?.name}
                  order={procedure?.steps[2]?.order}
                  disabled
                  isLast
                />
              </CommonBlock>
            </Block>
          )}
        </SubContainer>
      </Block>
      <Processing isOpen={isLoading} />

      <Modal
        show={showConfirmationModal}
        handleClose={handleCloseConfirmationModal}
      >
        <ConfirmationModal
          phone={phone}
          campusName={campusName}
          handleClick={registerIssuance}
          handleClose={handleCloseConfirmationModal}
        />
      </Modal>
    </ContainerProcedure>
  );
};

export default IssuanceUniversityCardRegisterView;
